import React from 'react';
import {
  Box,
  Typography,
  Grid,
  ListItem,
  Card,
  CardContent,
} from '@mui/material';
import { CheckCircle } from '@mui/icons-material';

const PlanConfirmation = ({ plan }) => {
  return (
    <Box sx={{ mt: 3 }}>
      <Typography variant="h6" gutterBottom>
        You&apos;ve selected:
      </Typography>

      <Card elevation={3} sx={{ p: 2, mb: 3 }}>
        <CardContent>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'flex-start',
            }}
          >
            <Typography variant="h5" sx={{ fontWeight: 600 }}>
              {plan.name}
            </Typography>
            <Box sx={{ textAlign: 'right' }}>
              <Typography variant="h5" color="primary" sx={{ fontWeight: 600 }}>
                £{plan.price}
              </Typography>
              <Typography
                variant="body2"
                color="textSecondary"
                sx={{ mt: 0.5 }}
              >
                + £50 Companies House Fee
              </Typography>
            </Box>
          </Box>

          <Box sx={{ mt: 2 }}>
            <Typography variant="body1" sx={{ fontWeight: 600 }}>
              Plan Features:
            </Typography>
            <Grid container spacing={2} sx={{ mt: 0.5 }}>
              {plan.features.map((feature, index) => (
                <Grid item xs={6} key={index}>
                  <ListItem sx={{ paddingLeft: 0 }}>
                    <CheckCircle color="primary" sx={{ mr: 2 }} />
                    <Typography variant="body1" color="textSecondary">
                      {feature}
                    </Typography>
                  </ListItem>
                </Grid>
              ))}
            </Grid>
          </Box>
        </CardContent>
      </Card>

      <Typography variant="body1" sx={{ textAlign: 'right', fontWeight: 600 }}>
        Click Next to proceed with your registration
      </Typography>
    </Box>
  );
};

export default PlanConfirmation;
